import { beliveClient, beliveApiWraper } from './belive-client'
import { buzzebeesClient, buzzebeesApiWraper } from './buzzebees-client'
import { createMethod } from './tools'

export const api = {
  belive: createMethod(beliveClient, beliveApiWraper),
  buzzebees: createMethod(buzzebeesClient, buzzebeesApiWraper),
}
